import {getCorePrefix} from "Services/Endpoints";

const prefix = getCorePrefix();

export const API_EMAIL_TEMPLATES = {
    templates: `${prefix}email-templates/`,
};
